export default "__VITE_PUBLIC_ASSET__dcacc00c__"